export default __webpack_public_path__ + "static/expTablet-e23fbbbf5706896a7960e11a5124a616.mp4";